export default __webpack_public_path__ + "static/media/architecture_diagram.a6da4f7d.png";